import { gql } from '@apollo/client/core'
  
const summaryReturnedFields = `
        name
        path
        _id
        isActive
        organisation {
          _id
          path
          name
          isActive
        }
`

/**
 * SUMMARY QUERY
 * Fetches lightweight info for list view
 */
export const SUMMARY_QUERY = gql`
  query CompanySummary {
    items: companiesByFields {
     ${summaryReturnedFields}
    }
  }
`
// welcomeEmail
//     resetEmail
//     dataRetention
//     customDomain
//     customDomainEmail
//     apiKey
/**
 * DETAIL QUERY
 * Fetches full info for editing
 */
export const DETAIL_QUERY = gql`
  query CompanyDetail($id: MongoID!) {
    item: companyById(_id: $id){
    _id
    name
    logo
    msAllowSSO 
    msCompanyAdminGroupID 
    msTenantID
    path
    organisation{
      _id
      name
    }
    showOrgOnLogin
    isActive
    primaryColour
    secondaryColour
    cost {
      currency
      costs {
        costId {
          displayName
          _id
        }
        organisationPrice
        userPrice
      }
    }
    welcomeEmail{
      iden
      subject
      body
    }
    resetEmail { 
      iden
      subject
      body
    }
    dataRetention { 
      isActive
      numOfDays
    }
    customDomain
    customDomainEmail
    address { 
      first
      second
      third
      fourth
      fifth
      sixth
     }
    }
  }
    
`

/**
 * CREATE MUTATION
 */
export const CREATE_MUTATION = gql`
  mutation CompanyCreateOne($record: CreateOneCompanyInput!) { 
    saveItem: companyCreateOne(record: $record) {
      recordId 
      record {    
        ${summaryReturnedFields}
      }  
    } }`

/**
 * UPDATE MUTATION
 * Note: The returned fields should only include those managed by the company privilege.
 * Some fields such as Path, iden, should not be editable by company admins and thus are not returned here to avoid confusion.
 */
export const UPDATE_MUTATION = gql`
  mutation UpdateCompany($filter: FilterUpdateOneCompanyInput, $record: UpdateOneCompanyInput!) {
    saveItem: companyUpdateOne(filter: $filter, record: $record){
    recordId
    record { 
      _id
      name
      logo
      msAllowSSO 
      msCompanyAdminGroupID 
      msTenantID
      path
      showOrgOnLogin
      isActive
      secondaryColour
      primaryColour
      cost {
        currency
        costs {
          organisationPrice
          userPrice
          costId {
            _id
          }
        }
      }
      address { 
        first
        second
        third
        fourth
        fifth
        sixth
      }
      apiKey
     }
    }
  }
`

/**
 * DELETE MUTATION
 */
export const DELETE_MUTATION = gql`
  mutation RemoveCompanys($id: MongoID!) {
    companyRemoveById(_id: $id){
    recordId
    }
  }
`
